import React from 'react'
import './CaseStudyHero.scss'

// import Social from './../lib/Social'

// const shareURL = (type) => {
//   if (type === 'twitter') {
//     Social.twitter(
//       window.location.href,
//       'Check out this case study from Colormatics',
//     )
//   } else {
//     Social[type](window.location.href)
//   }
// }

const CaseStudyHero = ({ textColor, content, type }) => {
  const newColor = textColor ? textColor : '#fff'

  const [active, setActive] = React.useState(false)

  React.useEffect(() => {
    setActive(true)
  })

  const tags = content.tags
    ? content.tags
        .map((item) =>
          item.tag.document ? item.tag.document.data.title.text : '',
        )
        .join(', ')
    : null

  return (
    <div className={`case-study-hero ${active ? 'active' : ''}`}>
      <div
        className="case-study-hero__background"
        style={{ backgroundImage: `url(${content.hero.fluid.src})` }}
      ></div>
      {type !== 'service' && type !== 'industry' && type !== 'location' && (
        <div className="case-study-hero__label verticle-text">
          <span>Case Study</span>
        </div>
      )}
      <div className="container">
        <div
          className={`case-study-hero__content ${
            type === 'service' || type === 'industry' || type === 'location'
              ? 'v-center'
              : ''
          }`}
        >
          <div className="case-study-hero__content-inner">
            <a
              href={
                type === 'service'
                  ? '/services'
                  : type === 'industry'
                  ? '/industries'
                  : type === 'location'
                  ? '/contact'
                  : '/case-studies'
              }
              className="back-btn"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16.646"
                height="27.217"
                viewBox="0 0 16.646 27.217"
              >
                <path
                  style={{
                    fill: 'none',
                    stroke: '#fff',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'bevel',
                    'stroke-width': '4px',
                  }}
                  d="M2253.734,299.445l-12.516,10.732,12.516,10.843"
                  transform="translate(-2239.909 -296.625)"
                />
              </svg>
            </a>
            {type !== 'service' && type !== 'industry' && type !== 'location' && (
              <div className="case-study-hero__logo">
                <img src={content.logo.fluid.src} alt="Amex Logo" />
              </div>
            )}
            <div
              style={{ color: newColor }}
              dangerouslySetInnerHTML={{ __html: content.title.html }}
            />
            {tags && tags !== '' && (
              <div className="meta">
                <span className="tag">{tags}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default CaseStudyHero
